// extracted by mini-css-extract-plugin
export default {"footerContainer":"AdminFooter_footerContainer__gfNw2","adminFooterMenu":"AdminFooter_adminFooterMenu__7aJp4"};